@if (apiError()) {
  <app-error [apiError]="apiError()" />
}

@if (isLoading()) {
  <app-loading />
} @else if (config()) {
  <div class="flex flex-col gap-6">
    <app-product-config-vat [productId]="productId()" [config]="config()!" (changed)="onVatChanged($event)" />

    @if (editing() || !hasLimits()) {
      <app-product-config-form
        [productId]="productId()"
        [config]="config()!"
        (saved)="onLimitsSaved($event)"
        (cancelled)="onEditCancelled()" />
    } @else {
      <app-product-config-view [config]="config()!" (editRequested)="onEditRequested()" />
    }
  </div>
}
